import { render } from "./upload_gallery_drag.vue?vue&type=template&id=5863811d&scoped=true"
import script from "./upload_gallery_drag.vue?vue&type=script&lang=js"
export * from "./upload_gallery_drag.vue?vue&type=script&lang=js"

import "./upload_gallery_drag.vue?vue&type=style&index=0&id=5863811d&scoped=true&lang=css"
import "./upload_gallery_drag.vue?vue&type=style&index=1&id=5863811d&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5863811d"]])

export default __exports__